import { Button } from '@core/ui';
import { ChangePasswordFormCancelButtonProps } from './types';

export const ChangePasswordFormCancelButton = ({ children, ...props }: ChangePasswordFormCancelButtonProps) => {
    return (
        <Button variant="primary-outline" {...props}>
            {children}
        </Button>
    );
};
